<template>
    <div class="white-bg cloud">
        <h2 class="side-title">标签云</h2>
        <ul>
            <a href="../e/tags/index-tagid=35&amp;tempid=8.html" target="_blank">SEO(1)</a> <a
                href="../e/tags/index-tagid=9&amp;tempid=8.html" target="_blank">收获(1)</a> <a
                href="../e/tags/index-tagid=14&amp;tempid=8.html" target="_blank">爱情(1)</a> <a
                href="../e/tags/index-tagid=37&amp;tempid=8.html" target="_blank">建站(1)</a> <a
                href="../e/tags/index-tagid=54&amp;tempid=8.html" target="_blank">建站流程(1)</a> <a
                href="../e/tags/index-tagid=30&amp;tempid=8.html" target="_blank">职业生涯(1)</a> <a
                href="../e/tags/index-tagid=61&amp;tempid=8.html" target="_blank">帝国cms(1)</a> <a
                href="../e/tags/index-tagid=47&amp;tempid=8.html" target="_blank">今夕何夕(1)</a> <a
                href="../e/tags/index-tagid=21&amp;tempid=8.html" target="_blank">心灵鸡汤(1)</a> <a
                href="../e/tags/index-tagid=27&amp;tempid=8.html" target="_blank">女程序员(3)</a> <a
                href="../e/tags/index-tagid=42&amp;tempid=8.html" target="_blank">搜索排名(1)</a> <a
                href="../e/tags/index-tagid=29&amp;tempid=8.html" target="_blank">赛跑(1)</a> <a
                href="../e/tags/index-tagid=25&amp;tempid=8.html" target="_blank">北大青鸟(1)</a> <a
                href="../e/tags/index-tagid=13&amp;tempid=8.html" target="_blank">思源夜景(1)</a> <a
                href="../e/tags/index-tagid=52&amp;tempid=8.html" target="_blank">企业网站(10)</a> <a
                href="../e/tags/index-tagid=44&amp;tempid=8.html" target="_blank">设计原则(1)</a> <a
                href="../e/tags/index-tagid=20&amp;tempid=8.html" target="_blank">程序员(7)</a> <a
                href="../e/tags/index-tagid=46&amp;tempid=8.html" target="_blank">个人博客模板(1)</a> <a
                href="../e/tags/index-tagid=10&amp;tempid=8.html" target="_blank">个人博客(5)</a> <a
                href="../e/tags/index-tagid=15&amp;tempid=8.html" target="_blank">遇见(1)</a></ul>
    </div>
</template>

<script>
    export default {
        name: "TagsBox"
    }
</script>

<style scoped>

</style>